import React, { createContext, useContext, useState, useEffect } from "react";
import { useAnalysis } from "./AnalysisContext";

// Create a context
const DateSelectionContext = createContext();

// Provider component
export const DateSelectionProvider = ({ children }) => {
  const { ndmiResults, ndreResults, ndviResults, msaviResults, nccResults, allMSAVIvalidJsonArrays, allNDREvalidJsonArrays, allNDVIvalidJsonArrays, allNDMIvalidJsonArrays } = useAnalysis();
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedUrl, setSelectedUrl] = useState(null);
  const [indicesDate, setIndicesDate] = useState([]);

  // Function to extract dates and URLs from the analysis results
  const extractDates = (resultsArray) => {
    let extractedDates = resultsArray
      .filter(result => result.Date && result.Url)
      .map(result => {
        const date = new Date(result.Date);
        return {
          date: `${date.getUTCDate()}-${(date.getUTCMonth() + 1).toString().padStart(2, "0")}-${date.getUTCFullYear()}`,
          url: result.Url,
        };
      });

    return extractedDates;
  };

  useEffect(() => {
    let allDates = [
      ...extractDates(ndmiResults),
      ...extractDates(ndreResults),
      ...extractDates(ndviResults),
      ...extractDates(msaviResults),
      ...extractDates(nccResults),
    ];

    setDates(allDates);
    setIndicesDate(allDates.map(item => item.date)); // Update indicesDate with extracted dates
  }, [ndmiResults, ndreResults, ndviResults, msaviResults, nccResults]);

  // Effect to update localStorage when indicesDate changes
  useEffect(() => {
    if (indicesDate.length > 0) {
      localStorage.setItem("extractedDates", JSON.stringify(indicesDate)); 
    }
  }, [indicesDate]); // This ensures localStorage updates only after indicesDate is set

  // Function to select a date and retrieve the corresponding URL
  const selectDate = (date) => {
    const match = dates.find((d) => d.date === date);
    setSelectedDate(date);
    setSelectedUrl(match ? match.url : null);
    localStorage.setItem("SelectedDate", JSON.stringify(date)); 
  };

  // Update selectedUrl whenever selectedDate changes
  useEffect(() => {
    if (selectedDate) {
      const match = dates.find((d) => d.date === selectedDate);
      setSelectedUrl(match ? match.url : null);
    }
  }, [selectedDate, dates, allMSAVIvalidJsonArrays, allNDREvalidJsonArrays, allNDVIvalidJsonArrays, allNDMIvalidJsonArrays]);

  return (
    <DateSelectionContext.Provider value={{ dates, selectedDate, selectedUrl, selectDate }}>
      {children}
    </DateSelectionContext.Provider>
  );
};

// Custom hook to use the DateSelectionContext
export const useDateSelection = () => {
  const context = useContext(DateSelectionContext);
  if (!context) {
    throw new Error("useDateSelection must be used within a DateSelectionProvider");
  }
  return context;
};
